import { render, staticRenderFns } from "./FeedCreate.vue?vue&type=template&id=3d7776f8&scoped=true"
import script from "./FeedCreate.vue?vue&type=script&lang=js"
export * from "./FeedCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7776f8",
  null
  
)

export default component.exports